import { Link } from 'react-router-dom';

type Props = {
  to: string;
  /** Por defecto: volver */
  ariaLabel?: string;
};

export function ScreenBackButton({ to, ariaLabel = 'Volver' }: Props) {
  return (
    <Link to={to} className="pwa-back-btn" aria-label={ariaLabel}>
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden>
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.2" d="M15 6l-6 6 6 6" />
      </svg>
    </Link>
  );
}
